<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_company_information") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h5 style="color: #724c80" class="font-weight-bold">
            {{ $t("PLACEHOLDERS.summaryData") }}
          </h5>
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="admin_image"
            :placeholder="$t('PLACEHOLDERS.company_logo')"
            @selectImage="selectImage"
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.company_name')"
            v-model.trim="data.name"
            required
          />
          <!-- End:: Name Input -->
          <!-- Start:: Name Input -->
          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.company_overview')"
            v-model.trim="data.about_company"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Phone Input -->
          <base-input
            ref="phoneInput"
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.mobile"
            required
          />
          <!-- End:: mobile Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
          />
          <!-- End:: Email Input -->

          <base-select-input
            col="6"
            :optionsList="areas"
            :placeholder="$t('PLACEHOLDERS.ar_or_city')"
            v-model="data.area_id"
            required
          />

          <div>
            <div class="col-12 mb-3 input_wrapper top_label select_wrapper">
              <GmapAutocomplete
                @place_changed="setPlace"
                @keyup.enter.stop="setPlace"
                :placeholder="$t('PLACEHOLDERS.search_place')"
              />
            </div>
            <GmapMap
              :center="center"
              :zoom="7"
              map-type-id="terrain"
              style="width: 100%; height: 300px"
              @click="handleMapClick"
            >
              <GmapMarker
                :position="marker.position"
                :clickable="true"
                :draggable="true"
                @click="markerClicked"
                @dragend="markerDragged($event)"
              />
            </GmapMap>
          </div>

          <!-- Start:: Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password')"
            v-model.trim="data.password"
            required
          />
          <!-- End:: Password Input -->

          <!-- Start:: Confirm Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.confirmPassword')"
            v-model.trim="data.password_confirmation"
            required
          />

          <!-- End:: Confirm Password Input -->
          <h5 style="color: #724c80" class="font-weight-bold mt-5">
            {{ $t("PLACEHOLDERS.about_company") }}
          </h5>

          <base-select-input
            col="6"
            :optionsList="fields"
            :placeholder="$t('PLACEHOLDERS.company_field')"
            v-model="data.field_id"
            required
            multiple
          />

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.company_size')"
            v-model.number="data.company_size"
            required
          />

          <!-- Start:: Deactivate Switch Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.company_url')"
            v-model.trim="data.company_url"
          />

          <!-- Start:: Submit Button Wrapper -->

          <!-- Start:: date Input -->
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.found_date')"
            v-model.trim="data.found_date"
            required
          />
          <!-- End:: date Input -->

          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.company_description')"
            v-model.trim="data.company_description"
            required
          />

          <label style="color: #724c80" class="form-label">
            {{ $t("PLACEHOLDERS.commercial_register") }}
            <span class="text-danger">*</span>
          </label>

          <div class="col-6">
            <div
              class="upload-icon-wrapper"
              @click="$refs.commercial_regiserInput.click()"
              style="cursor: pointer"
            >
              <i
                class="fas fa-upload"
                style="font-size: 25px; color: #724c80"
              ></i>
              <span class="mx-2 text-gray-300">{{
                data.commercial_regiser
                  ? data.commercial_regiser.name
                  : $t("PLACEHOLDERS.uploadCv")
              }}</span>
              <i
                v-if="data.commercial_regiser"
                class="fas fa-times text-danger mx-2"
                style="cursor: pointer"
                @click.stop="data.commercial_regiser = null"
              ></i>
              <input
                ref="commercial_regiserInput"
                type="file"
                accept=".pdf, .png, .jpeg, .jpg"
                @change="
                  (e) => {
                    const file = e.target.files[0];
                    const allowedTypes = ['.pdf', '.png', '.jpeg', '.jpg'];
                    const fileExtension =
                      '.' + file.name.split('.').pop().toLowerCase();

                    if (!allowedTypes.includes(fileExtension)) {
                      this.$message.error(this.$t('MESSAGES.invalidFileType'));
                      e.target.value = '';
                      return;
                    }

                    this.data.commercial_regiser = file;
                  }
                "
                style="display: none"
              />
            </div>
          </div>

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";

export default {
  name: "CreateAdmin",
  components: { ChangableMapComponent },
  data() {
    return {
      latitude: 24.7136,
      longitude: null,
      markers: [],
      center: { lat: 24.7136, lng: 46.6753 },
      zoom: 10,
      currentPlace: null,
      marker: {
        position: { lat: null, lng: null },
        markers: [],
        center: { lat: 24.7136, lng: 46.6753 },
        zoom: 10,
        currentPlace: null,
        marker: {
          position: { lat: 24.7136, lng: 46.6753 },
        },
      },

      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        logo: {
          path: null,
          file: null,
        },
        have_experience: null,
        name: null,
        about_company: null,
        email: null,
        mobile: null,
        birthday: null,
        area_id: null,
        password: null,
        password_confirmation: null,
        company_size: null,
        company_url: "",
        found_date: null,
        educational_qualification_id: null,
        scope_work_id: true,
        field_id: [],
        commercial_regiser: null,
        experiences: [
          {
            company_name: null,
            years: null,
            from_date: null,
            to_date: null,
          },
        ],
      },
      qualifications: [],
      areas: [],
      works: [],
      fields: [],
      allAreas: [],
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
    // End:: Vuex Getters
    expStatus() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.yes"),
          value: "yes",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.no"),
          value: "no",
        },
      ];
    },
  },

  methods: {
    // Start:: Vuex Actions
    ...mapActions({
      getRoles: "ApiGetsModule/getRoles",
    }),
    // End:: Vuex Actions
    addRow() {
      this.data?.experiences.push({
        company_name: null,
        years: null,
        from_date: null,
        to_date: null,
      });
    },

    removeRow(index) {
      this.data?.experiences.splice(index, 1);
    },
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.logo = selectedImage;
    },
    selectcommercial_regiser(selectedImage) {
      this.data.commercial_regiser = selectedImage;
    },
    // End:: Select Upload Image

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: validate Form Inputs
    async getAreas() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `areas?page=0&limit=0&is_active=1`,
        });
        this.areas = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getWorks() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `scope-works?page=0&limit=0&is_active=1`,
        });
        this.works = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getFields() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `company-fields`,
        });
        console.log(res.data.data.data);
        this.fields = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getQualifications() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `educational-qualifications?page=0&limit=0&is_active=1`,
        });
        this.qualifications = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.logo.file) {
        REQUEST_DATA.append("logo", this.data.logo.file);
      }
      if (this.data.commercial_regiser) {
        REQUEST_DATA.append(
          "commercial_register",
          this.data.commercial_regiser
        );
      }
      if (this.data.name) {
        REQUEST_DATA.append("name", this.data.name);
      }
      if (this.data.about_company) {
        REQUEST_DATA.append("about_company", this.data.about_company);
      }
      if (this.data.mobile) {
        REQUEST_DATA.append("mobile", this.data.mobile);
      }
      if (this.data.email) {
        REQUEST_DATA.append("email", this.data.email);
      }
      if (this.data.birthday) {
        REQUEST_DATA.append("birthday", this.data.birthday);
      }
      if (this.data.area_id?.id) {
        REQUEST_DATA.append("area_id", this.data.area_id.id);
      }
      if (this.data.password) {
        REQUEST_DATA.append("password", this.data.password);
      }
      if (this.data.password_confirmation) {
        REQUEST_DATA.append(
          "password_confirmation",
          this.data.password_confirmation
        );
      }

      if (this.data.company_url) {
        REQUEST_DATA.append("website", this.data.company_url);
      }
      if (this.data.company_size) {
        REQUEST_DATA.append("company_size", this.data.company_size);
      }
      if (this.data.found_date) {
        REQUEST_DATA.append("foundation_date", this.data.found_date);
      }

      if (this.data.company_description) {
        REQUEST_DATA.append("description", this.data.company_description);
      }
      if (this.data.field_id) {
        this.data.field_id.forEach((field, index) => {
          REQUEST_DATA.append(`company_field_id[${index}]`, field.id);
        });
      }
      if (!this.marker.position.lat || !this.marker.position.lng) {
        this.$message.error(this.$t("VALIDATION.location_required"));
        this.isWaitingRequest = false;
        return;
      }
      if (this.marker.position) {
        REQUEST_DATA.append(`latlng[0]`, this.marker.position.lat);
        REQUEST_DATA.append(`latlng[1]`, this.marker.position.lng);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `companies`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/companies/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    handleMapClick(event) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();

      this.marker.position = { lat, lng };

      const radius = this.calculateDistance(
        lat,
        lng,
        this.center.lat,
        this.center.lng
      );

      const geocoder = new google.maps.Geocoder();
      const latLng = new google.maps.LatLng(lat, lng);

      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === "OK" && results[0]) {
          this.Latitude = lat;
          this.Longitude = lng;
          this.Radius = radius;
          this.place = results[0].formatted_address;

          console.log("Latitude:", lat);
          console.log("Longitude:", lng);
          console.log("Radius:", radius);
          console.log("Place:", results[0].formatted_address);

          this.marker.position = { lat, lng }; // Update the marker's position
        }
      });
    },

    calculateDistance(lat1, lng1, lat2, lng2) {
      const R = 6371; // Radius of the earth in kilometers
      const dLat = this.deg2rad(lat2 - lat1);
      const dLng = this.deg2rad(lng2 - lng1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLng / 2) *
          Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c * 1000; // Convert to meters
      return distance;
    },
    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
    handleMarkerClick(index) {
      console.log("Marker clicked:", index);
    },
    markerClicked() {
      // Handle marker click event
      const lat = this.marker.position.lat;
      const lng = this.marker.position.lng;
      const radius = this.calculateDistance(
        lat,
        lng,
        this.center.lat,
        this.center.lng
      );
      console.log("Marker clicked:", lat, lng);
      console.log(radius);
    },

    async markerDragged(event) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();

      const radius = this.calculateDistance(
        lat,
        lng,
        this.center.lat,
        this.center.lng
      );

      try {
        const geocoder = new google.maps.Geocoder();
        const latLng = new google.maps.LatLng(lat, lng);
        const results = await this.reverseGeocode(lat, lng, geocoder);

        if (results.length > 0) {
          this.Latitude = lat;
          this.Longitude = lng;
          this.Radius = radius;
          this.place = results[0].formatted_address;

          this.marker.position = { lat, lng };
        }
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    },
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },

    addMarker() {
      if (
        this.currentPlace &&
        this.currentPlace.geometry &&
        this.currentPlace.geometry.location
      ) {
        this.marker.position.lat = this.currentPlace.geometry.location.lat();
        this.marker.position.lng = this.currentPlace.geometry.location.lng();

        this.Latitude = this.currentPlace.geometry.location.lat();
        this.Longitude = this.currentPlace.geometry.location.lng();

        this.center.lat = this.currentPlace.geometry.location.lat();
        this.center.lng = this.currentPlace.geometry.location.lng();
        this.currentPlace = null;
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    // End:: Fire Methods
    this.getFields();
    this.getWorks();
    this.getQualifications();
    this.getAreas();
    this.$nextTick(() => {
      this.data.mobile = "";
    });
  },
};
</script>

<style>
form .input_wrapper.top_label input {
  width: 100% !important;
}
</style>
